(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["divag-home"]) return;
  try {
    
function initDivagQuickAdd(root) {
(root || document).querySelectorAll('.dv-pcard-img').forEach(function(card){
if(card.dataset.quickAddReady === 'true')return;
var openBtn=card.querySelector('[data-qa-open]');var panel=card.querySelector('.dv-qa');if(!openBtn||!panel)return;
card.dataset.quickAddReady='true';
var form=panel.querySelector('.dv-qa-form');var idInput=form.querySelector('input[name=id]');var addBtn=form.querySelector('.dv-qa-add');
var variants=[];try{variants=JSON.parse(form.dataset.variants);}catch(error){return;}var groups=Array.prototype.slice.call(form.querySelectorAll('.dv-qa-opt'));var selected={};
openBtn.addEventListener('click',function(){panel.hidden=false;openBtn.style.display='none';});
var closeBtn=panel.querySelector('[data-qa-close]');if(closeBtn)closeBtn.addEventListener('click',function(){panel.hidden=true;openBtn.style.display='';});
function refresh(){groups.forEach(function(g){var i=+g.dataset.optIndex;g.querySelectorAll('.dv-qa-val').forEach(function(b){var val=b.dataset.value;var ok=variants.some(function(v){if(!v.available)return false;if(v.options[i]!==val)return false;return groups.every(function(g2){var j=+g2.dataset.optIndex;return j===i||selected[j]==null||v.options[j]===selected[j];});});b.disabled=!ok;});});
var all=groups.every(function(g){return selected[+g.dataset.optIndex]!=null;});var m=all?variants.find(function(v){return groups.every(function(g){var i=+g.dataset.optIndex;return v.options[i]===selected[i];});}):null;
if(m&&m.available){idInput.value=m.id;addBtn.disabled=false;}else{idInput.value='';addBtn.disabled=true;}}
groups.forEach(function(g){var i=+g.dataset.optIndex;g.querySelectorAll('.dv-qa-val').forEach(function(b){b.addEventListener('click',function(){if(b.disabled)return;if(selected[i]===b.dataset.value){selected[i]=null;b.setAttribute('aria-pressed','false');}else{selected[i]=b.dataset.value;g.querySelectorAll('.dv-qa-val').forEach(function(x){x.setAttribute('aria-pressed','false');});b.setAttribute('aria-pressed','true');}refresh();});});});
refresh();
});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initDivagQuickAdd(document);},{once:true});}else{initDivagQuickAdd(document);}
document.addEventListener('shopify:section:load',function(event){initDivagQuickAdd(event.target);});

  } catch(e) { console.error(e); }
})();
})();
